import * as React from 'react';
import { useCallback, useMemo } from 'react';
import ButtonBase from '@mui/material/ButtonBase';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { CdnIcon } from '@shared/ui';
import Money from '../../../Money';
import Button from '../../../BaseComponents/Button';
import { SafeHtml } from '@shared/ui';
const AggregatorService = ({ className, coverClassName, descriptionClassName, coverBackgroundColor, coverBackgroundUrl, aggregationIcons, header, description, children, priceFrom, priceTotal, discount, buttons, displayOrder, hideFooterButtons, isSelected, isLoading, addClick, onDelete, renderHeaderPrice }) => {
    var _a;
    const theme = useTheme('CheckoutAdditionalService').AggregatorService;
    const { t } = useTranslation('CheckoutAdditionalService');
    const hasTotalPrice = (priceTotal === null || priceTotal === void 0 ? void 0 : priceTotal.amount) > 0;
    const hasFromPrice = (priceFrom === null || priceFrom === void 0 ? void 0 : priceFrom.amount) >= 0;
    const hasPrice = hasTotalPrice || hasFromPrice;
    const filteredButtons = useMemo(() => {
        if (!buttons || !isSelected) {
            return [];
        }
        if (isLoading) {
            return [buttons[0]];
        }
        return buttons;
    }, [buttons, isSelected, isLoading]);
    const onDescriptionClickHandler = (e) => {
        var _a;
        if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.tagName) === 'A') {
            e.stopPropagation();
        }
    };
    const onAddHandler = useCallback((e) => {
        e.stopPropagation();
        addClick();
    }, [addClick]);
    return (React.createElement("div", { className: cn(theme.container, className, {
            [theme.container_active]: !isSelected
        }), onClick: !isSelected ? addClick : () => { }, style: { order: displayOrder } },
        React.createElement("div", { className: cn(theme.cover, coverClassName), style: { background: coverBackgroundColor } },
            coverBackgroundUrl && React.createElement("img", { className: theme.image, src: coverBackgroundUrl }),
            !isSelected && (React.createElement(ButtonBase, { onClick: onAddHandler, className: theme.add, "aria-hidden": "false" },
                React.createElement(CdnIcon, { icon: "Action/Add" }))),
            isSelected && React.createElement("div", { className: cn(theme.checked, { [theme.checked_removable]: !!onDelete }) }),
            aggregationIcons && (React.createElement("div", { className: theme.icons }, aggregationIcons.map((icon, key) => typeof icon === 'string' ? (React.createElement(CdnIcon, { key: `${icon}-${key}`, icon: icon })) : (React.createElement(React.Fragment, { key: key }, icon)))))),
        React.createElement("div", { className: theme.content },
            React.createElement("div", { className: theme.header }, header),
            isSelected ? (React.createElement("div", { className: theme.content__services }, children)) : (React.createElement("div", { className: cn(theme.description, descriptionClassName) },
                discount && React.createElement("div", { className: theme.discount }, discount),
                React.isValidElement(description) &&
                    React.cloneElement(description, { onClick: onDescriptionClickHandler }),
                !React.isValidElement(description) && (React.createElement(SafeHtml, { tag: "div", onClick: onDescriptionClickHandler, html: description })))),
            React.createElement("div", { className: cn(theme.footer, {
                    [theme.footer_multiButtons]: isSelected && (filteredButtons === null || filteredButtons === void 0 ? void 0 : filteredButtons.length) > 1,
                    [theme.footer_hiddenButtons]: hideFooterButtons
                }) },
                !hideFooterButtons && (React.createElement("div", { className: theme.buttons }, filteredButtons.length > 0 ? (filteredButtons.map((button, index) => (React.createElement(Button, { key: index, variant: "optionEdit", className: theme.button, isLoading: isLoading || button.isLoading, onClick: button.action }, button.text)))) : (React.createElement(Button, { variant: "optionAction", className: cn(theme.button, theme.button_add), isLoading: isLoading, onClick: onAddHandler }, t('Add'))))),
                hasPrice && (React.createElement("div", { className: theme.totalPrice }, isSelected
                    ? (_a = renderHeaderPrice === null || renderHeaderPrice === void 0 ? void 0 : renderHeaderPrice()) !== null && _a !== void 0 ? _a : (hasTotalPrice && (React.createElement(React.Fragment, null,
                        t('Total'),
                        ": ",
                        React.createElement(Money, { money: priceTotal }))))
                    : hasFromPrice && (React.createElement(React.Fragment, null,
                        t('from'),
                        " ",
                        React.createElement(Money, { money: priceFrom })))))))));
};
export default AggregatorService;
